import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {LocationModel} from '@/libs/Api';
import {LocationsDataService} from '@/libs/locations/locations-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const locationsStore = registerCrudStore<LocationModel, LocationModel>(BusinessModule.Location, new LocationsDataService());
